import type { Account } from '@modules-deprecated/app/accounts/types'

export const getAccountLabel = (account: Account): string =>
  `${account.accountNo ? `${account.accountNo} - ` : ''}${account.name}`
